export default "__VITE_ASSET__BZQTsbPJ__"